import { Button } from 'component/Button'
import { Gap, Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { MeasurementsBanner } from 'feature/measurements/MeasurementsBanner'
import { MeasurementsButton } from 'feature/measurements/MeasurementsButton'
import { measurements_banner, useMeasurementsBanner } from 'feature/measurements/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { ErrorPopover } from 'page/ProfileScreen/ErrorPopover/ErrorPopover'
import { FullPhotoSelect } from 'page/ProfileScreen/FullProfilePage/FullPhotoSelect'
import { FullStep } from 'page/ProfileScreen/FullStep/FullStep'
import { PhotoHelpStep } from 'page/ProfileScreen/HelpStep/PhotoHelpStep'
import { ProfileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModal'
import { profileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModalStore'
import { SaveButton } from 'page/ProfileScreen/SaveButton/SaveButton'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const FullProfilePage = observer(() => {
  const { userPhoto } = store.profile.common
  const data_management = false

  useMeasurementsBanner()

  const onBack = useLatestCallback(() => {
    controller.closeProfile()
  })

  const onData = useLatestCallback(async () => {
    store.profile.step = 'data'
  })

  return (
    <Page full onBack={onBack}>
      <Vertical pad={[0, 16]} tall wide center>
        <Vertical minHeight="100%" wide maxWidth="var(--max-width)">
          <Space margin={[0, -16]} spring>
            <FullPhotoSelect />
          </Space>

          {opt.sizes && <Gap height={12} />}
          {opt.sizes && <MeasurementsButton profile={store.profile} />}

          <Gap height={12} />
          <Space>
            <ErrorPopover selfie={userPhoto} full />
            <SaveButton />
          </Space>

          {data_management && (
            <Button link={!opt.tsum} large={opt.tsum} action={onData}>
              {i18n('UserDataManagement')}
            </Button>
          )}

          {profileDeleteModal.present && <ProfileDeleteModal />}
          {measurements_banner.present && <MeasurementsBanner />}

          {store.profile.step === 'help' && <PhotoHelpStep />}
          {store.profile.step === 'full' && <FullStep />}
        </Vertical>
      </Vertical>
    </Page>
  )
})
